import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';  
import { Navigate, Outlet, useLocation } from 'react-router-dom';  
  
import { LoginContext } from './common/App';
import { NavigateSmart } from './common/Common';


export const MailConfirmedRoute = () => {
    const login = useContext(LoginContext);


    return (
        !login.loggedIn ?
            null
        :
            login.mailConfirmed ?
                <Outlet />
            :
                <NavigateSmart to="/confirm_mail/"/>
    );
};

export default MailConfirmedRoute
